<template>
  <fragment>
    <AppBody :subtitle="$t('registrations.users.title')" :actions="actions">
      <CardModule untitle>
        <ExpansionPanelFilters>
          <v-form
            @submit.prevent="$lojas_usuarios.filtroUsuarios()"
            class="search-forms"
          >
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  v-model="$lojas_usuarios.filter.nome"
                  :label="$t('registrations.users.name')"
                  :placeholder="$t('registrations.users.insert-name')"
                  data-cy="nome"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  v-model="$lojas_usuarios.filter.email"
                  :label="$t('registrations.users.email')"
                  :placeholder="$t('registrations.users.insert-email')"
                  data-cy="email"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  v-model="$lojas_usuarios.filter.status"
                  label="Status"
                  :placeholder="$t('registrations.users.select-status')"
                  :items="status"
                  data-cy="status"
                  clear-icon="mdi-close-circle-outline"
                  item-text="key"
                  item-value="value"
                  clearable
                  @click:clear="$lojas_usuarios.filter.status = ''"
                >
                </BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  v-model="$lojas_usuarios.filter.dataInicio"
                  :label="$t('registrations.users.register-initial-date')"
                  placeholder="dd/mm/aaaa"
                  :error-messages="$lojas_usuarios.filter.error.dataInicio"
                  v-mask="'##/##/####'"
                  data-cy="data-inicial"
                  append-icon="mdi-calendar-blank-outline"
                  @input="$lojas_usuarios.filter.error.dataInicio = []"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  v-model="$lojas_usuarios.filter.dataFim"
                  :label="$t('registrations.users.register-final-date')"
                  placeholder="dd/mm/aaaa"
                  :error-messages="$lojas_usuarios.filter.error.dataFim"
                  data-cy="data-final"
                  v-mask="'##/##/####'"
                  append-icon="mdi-calendar-blank-outline"
                  @input="$lojas_usuarios.filter.error.dataFim = []"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  v-model="$lojas_usuarios.filter.perfil"
                  :label="$t('registrations.users.profile')"
                  :placeholder="$t('registrations.users.select-profile')"
                  :items="perfil"
                  item-text="key"
                  item-value="value"
                  data-cy="perfil"
                  clearable
                  @click:clear="$lojas_usuarios.filter.perfil = ''"
                >
                </BaseSelect>
              </v-col>
              <v-col class="d-flex justify-end">
                <BaseButton
                  data-cy="filtrar"
                  variant="filter"
                  type="submit"
                  :loading="$lojas_usuarios.usuarios_loading_button"
                >
                  {{ $t("registrations.filter") }}
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </ExpansionPanelFilters>

        <v-data-table
          class="table-body"
          :no-data-text="$t('registrations.users.no-users-found')"
          :loading-text="$t('registrations.loading-info')"
          item-key="idusuario"
          mobile-breakpoint="0"
          :headers="headers"
          :loading="$lojas_usuarios.cadastro.loading"
          :items="tableValues"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: $t('registrations.users.users-per-page'),
          }"
        >
          <template v-slot:item.perfil="{ item }">
            {{
              item.perfil == "LOJISTA"
                ? "PRODUTOR"
                : item.perfil && item.perfil == "ADMIN"
                ? "ADMIN PRODUTOR"
                : item.perfil
            }}
          </template>
          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="goToUser('editar', item)"
                    class="mr-2"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("registrations.edit") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="item.status == 'ATIVO'"
                    :color="$config.dados.corinputs"
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    icon
                    @click="
                      $lojas_usuarios.desabilitarUsuarioLoja(item.idusuario)
                    "
                  >
                    <v-icon>mdi-account-cancel-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("registrations.disable") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="
                      item.status != 'ATIVO' || item.status == 'ACEITE_TERMOS'
                    "
                    :disabled="item.status == 'ACEITE_TERMOS'"
                    :color="$config.dados.corinputs"
                    height="30"
                    v-bind="attrs"
                    v-on="on"
                    width="30"
                    small
                    icon
                    @click="$lojas_usuarios.habilitarUsuario(item.idusuario)"
                  >
                    <v-icon>mdi-account-check-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("registrations.activate") }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </CardModule>
    </AppBody>
  </fragment>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "Users",
  metaInfo() {
    const title = this.$t("registrations.users.title");
    return {
      title: `${title} | ElevenTickets`,
      meta: [
        {
          property: "og:title",
          content: `${title} | ElevenTickets`,
        },
      ],
    };
  },
  props: {},
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
    BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
    ExpansionPanelFilters: () =>
      import("@/components/forms/ExpansionPanelFilters.vue"),
  },
  data() {
    return {
      loja: "",
      activePicker: null,
      activePicker2: null,
      date: null,
      menu: false,
      menu2: false,
      dtInicial: "",
      dtFinal: "",
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },
  },
  computed: {
    ...mapGetters(["storeSequencial", "isAdmin"]),
    actions() {
      return [
        {
          name: this.$t("registrations.users.new-user"),
          action: () => this.goToUser("new", ""),
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("registrations.users.name"),
          align: "center",
          sortable: true,
          value: "nome",
        },
        {
          text: this.$t("registrations.users.email"),
          align: "center",
          sortable: true,
          value: "email",
        },
        {
          text: this.$t("registrations.users.profile"),
          align: "center",
          sortable: true,
          value: "perfil",
        },
        {
          text: this.$t("registrations.users.register-date"),
          align: "center",
          sortable: true,
          value: "ins_dthr",
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
        },
        {
          text: this.$t("registrations.actions"),
          align: "center",
          value: "actions",
          sortable: false,
        },
      ];
    },
    perfil() {
      return [
        { key: "App", value: "APP" },
        { key: this.$t("registrations.users.producer"), value: "LOJISTA" },
        { key: this.$t("registrations.users.admin-producer"), value: "ADMIN" },
        { key: this.$t("registrations.users.event"), value: "EVENTO" },
      ];
    },
    status() {
      return [
        { key: this.$t("registrations.active"), value: "ATIVO" },
        { key: this.$t("registrations.inactive"), value: "INATIVO" },
      ];
    },
    pageTitle() {
      if (this.isAdmin) return "Produtores / Usuários";
      return "Loja / Usuário";
    },
    tableValues() {
      const self = this;
      if (
        this.$lojas_usuarios.usuarios &&
        this.$lojas_usuarios.usuarios.length > 0
      ) {
        this.$lojas_usuarios.usuarios.forEach(function (item) {
          item.ins_dthr = self.$config.convertDataBR(
            item.ins_dthr.substring(0, 10)
          );
        });
      }
      return _.orderBy(
        this.$lojas_usuarios.usuarios,
        usuario => {
          if (usuario.ins_dthr) {
            return new Date(
              usuario.ins_dthr.split("/").reverse().join("-")
            ).getTime();
          } else {
            return Number.MIN_VALUE;
          }
        },
        "desc"
      );
    },
  },
  methods: {
    goToUser(type, data) {
      this.$lojas_usuarios.usuarioAddEdit = type;
      if (type === "editar") {
        this.$router.push({
          name: "producersUserSettings",
          params: {
            type: "editar",
          },
        });
        this.$lojas_usuarios.cadastro.nome = data.nome;
        this.$lojas_usuarios.cadastro.email = data.email;
        this.$lojas_usuarios.cadastro.senha = data.senha;
        this.$lojas_usuarios.cadastro.urlHome = data.urlHome;
        this.$lojas_usuarios.cadastro.status = data.status;
        this.$lojas_usuarios.cadastro.iduserloja = data.idusuario;
        this.$lojas_usuarios.cadastro.perfil = data.perfil;
        this.$lojas_usuarios.cadastro.eventos = data.nideventos;
        this.$lojas_usuarios.cadastro.editar_evento = data.editar_evento;
        this.$lojas_usuarios.cadastro.avatar.imagem = data.avatar;

        return;
      }
      this.$router.push({
        name: "producersUserSettings",
        params: {
          type: "cadastrar",
        },
      });
    },
  },
  updated() {
    this.$axios.setLocal("loja_usuarios", this.$lojas_usuarios.loja_usuarios);
  },
  created() {
    const lojaNome = this.$axios.getLocal("loja_usuarios").data;
    if (lojaNome) {
      this.$lojas_usuarios.loja_usuarios = lojaNome;
    }
  },
  beforeMount() {
    if (this.storeSequencial) {
      this.$lojas_usuarios.getUsuariosLoja(this.storeSequencial);
    }
  },
  destroyed() {
    this.$lojas_usuarios.limpaFiltros();
    (this.$lojas_usuarios.loja_selecionada = ""),
      (this.$lojas_usuarios.usuarios = []),
      (this.$lojas_usuarios.cadastro.error.nome = ""),
      (this.$lojas_usuarios.cadastro.error.email = ""),
      (this.$lojas_usuarios.cadastro.error.senha = ""),
      (this.$lojas_usuarios.cadastro.error.status = "");
    this.$lojas_usuarios.cadastro.error.perfil = "";
    this.$lojas_usuarios.loja_usuarios = "";
  },
};
</script>

<style scoped></style>
